import React, { useEffect, useState, useContext } from 'react';
import { Modal, Tree, Result, Spin, Icon, Tag, Badge } from 'antd';
import { PContext } from '../../context/PendingContext';

const modalStyles = `
@keyframes od-bar   { 0%{background-position:0% center} 100%{background-position:200% center} }
@keyframes od-float { 0%,100%{transform:translateY(0px)} 50%{transform:translateY(-3px)} }
@keyframes od-glow  { 0%,100%{box-shadow:0 0 0 0 rgba(24,144,255,0.4)} 50%{box-shadow:0 0 0 10px rgba(0,0,0,0)} }
@keyframes modal-pop { from{opacity:0;transform:scale(0.96) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }
@keyframes od-spin-slow { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }

.od-modal .ant-modal-content { 
  border-radius:14px!important; 
  overflow:hidden!important; 
  box-shadow:0 24px 64px rgba(0,0,0,.16),0 0 0 1px rgba(24,144,255,.1)!important; 
  animation:modal-pop .3s cubic-bezier(.22,1,.36,1) both!important; 
}
.od-modal .ant-modal-header  { 
  padding:0!important; 
  border-bottom:none!important; 
}
.od-modal .ant-modal-body    { 
  padding:0!important; 
}
.od-modal .ant-modal-footer  { 
  display:none!important; 
}
.od-modal .ant-modal-close   { 
  top:14px!important; 
  right:16px!important; 
  color:rgba(255,255,255,0.8)!important; 
  transition:color .2s,transform .2s!important; 
}
.od-modal .ant-modal-close:hover { 
  color:#fff!important; 
  transform:rotate(90deg)!important; 
}
.od-modal .ant-modal-close .ant-modal-close-x { 
  width:36px!important; 
  height:36px!important; 
  line-height:36px!important; 
}

.od-header { 
  background:linear-gradient(135deg,#003a8c 0%,#0050b3 35%,#1890ff 70%,#096dd9 100%); 
  padding:18px 22px 16px; 
  display:flex; 
  align-items:center; 
  gap:14px; 
  position:relative; 
  overflow:hidden; 
}
.od-header::before { 
  content:''; 
  position:absolute; 
  inset:0; 
  background-image:radial-gradient(rgba(255,255,255,.09) 1px,transparent 1px); 
  background-size:20px 20px; 
  pointer-events:none; 
}
.od-header::after  { 
  content:''; 
  position:absolute; 
  bottom:0; 
  left:0; 
  right:0; 
  height:3px; 
  background:linear-gradient(90deg,#13c2c2,#1890ff,#52c41a,#fa8c16,#13c2c2); 
  background-size:300% auto; 
  animation:od-bar 3s linear infinite; 
}
.od-header-icon { 
  width:44px; 
  height:44px; 
  border-radius:12px; 
  background:rgba(255,255,255,.15); 
  border:1.5px solid rgba(255,255,255,.25); 
  display:flex; 
  align-items:center; 
  justify-content:center; 
  flex-shrink:0; 
  animation:od-glow 2.6s ease-in-out infinite, od-float 3s ease-in-out infinite; 
}
.od-header-title { 
  font-size:15px; 
  font-weight:800; 
  color:#fff; 
  letter-spacing:.8px; 
}
.od-header-sub   { 
  font-size:11px; 
  color:rgba(255,255,255,.6); 
  letter-spacing:1px; 
  margin-top:2px; 
}

.od-body { 
  padding:20px 22px; 
  min-height:180px;
  max-height: 70vh;
  overflow-y: auto;
}

.od-modal .ant-tree { 
  font-size:12px!important; 
  font-weight:500!important; 
}
.od-modal .ant-tree li .ant-tree-node-content-wrapper:hover { 
  background:#e6f7ff!important; 
  border-radius:6px!important; 
}
.od-modal .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected { 
  background:#bae7ff!important; 
  border-radius:6px!important; 
  font-weight:700!important; 
}
.od-modal .ant-tree-show-line .ant-tree-switcher { 
  background:#fff!important; 
  color:#1890ff!important; 
  font-weight:700!important; 
}
.od-modal .ant-spin-dot-item { 
  background:#1890ff!important; 
}
.od-modal .ant-result-title { 
  font-size:13px!important; 
  font-weight:700!important; 
  color:#595959!important; 
  letter-spacing:.5px!important; 
}

.od-stats-badge {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(19,194,194,.2);
  border: 1px solid rgba(19,194,194,.4);
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  color: #13c2c2;
  letter-spacing: .5px;
}
`;

const OverallDetailsModal = props => {
  const {
    visible,
    data: { id, po_num },
    closeModal,
  } = props;

  const [tree, setTrees] = useState({ treeData: [], treeDataParentKeys: [] });
  const { getPoDetails } = useContext(PContext);
  const [isLoading, setLoading] = useState(false);
  
  useEffect(() => {
    if (visible) {
      setLoading(true);
      getPoDetails(id)
        .then(res => {
          const { treeData, treeDataParentKeys } = res;
          setTrees({ treeData, treeDataParentKeys });
        })
        .finally(() => setLoading(false));
    }
  }, [visible, id, getPoDetails]);

  // Calculate tree statistics
  const getTreeStats = () => {
    if (!tree.treeData.length) return { categories: 0, items: 0 };
    
    const countItems = (nodes) => {
      let count = 0;
      nodes.forEach(node => {
        if (node.children && node.children.length > 0) {
          count += countItems(node.children);
        } else {
          count++;
        }
      });
      return count;
    };
    
    return {
      categories: tree.treeData.length,
      items: countItems(tree.treeData)
    };
  };
  
  const stats = getTreeStats();

  return (
    <>
      <style>{modalStyles}</style>
      <Modal
        className="od-modal"
        onCancel={() => (isLoading ? null : closeModal())}
        style={{ top: 20 }}
        visible={visible}
        width="75%"
        footer={null}
        title={
          <div className="od-header">
            <div className="od-header-icon">
              <Icon type="profile" style={{ fontSize: 20, color: '#fff' }} />
            </div>
            <div>
              <div className="od-header-title">{po_num || 'PO DETAILS'}</div>
              <div className="od-header-sub">Purchase Order Overview</div>
            </div>
            <div className="od-stats-badge">
              <Icon type="partition" style={{ fontSize: 10 }} />
              {stats.categories} Categories • {stats.items} Items
            </div>
          </div>
        }
      >
        <div className="od-body">
          <Spin spinning={isLoading} tip="Loading item details...">
            {tree.treeData.length > 0 ? (
              <Tree
                blockNode
                defaultExpandAll
                treeData={tree.treeData}
                showLine
                icon={({ expanded }) => (
                  <Icon 
                    type={expanded ? 'folder-open' : 'folder'} 
                    style={{ color: '#1890ff', fontSize: 14 }}
                  />
                )}
              />
            ) : (
              !isLoading && (
                <Result 
                  title="NO ITEMS FOUND" 
                  status="info" 
                  icon={<Icon type="inbox" style={{ fontSize: 48, color: '#1890ff' }} />}
                  subTitle="This purchase order has no items listed."
                />
              )
            )}
          </Spin>
        </div>
      </Modal>
    </>
  );
};

export default OverallDetailsModal;